export default __webpack_public_path__ + "static/media/medium.cd43a100.svg";